import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-subtitle',
  imports: [],
  templateUrl: './subtitle.component.html'
})
export class SubtitleComponent {
  @Input()
  text: string
}
